module.exports = __webpack_public_path__ + "img/live-streaming-benefits.4650aa5c.png";